module.exports = {
	"articleTitle1": "Iconic State Theatre to close for renovations ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "State Theater",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/michigan-theater-foundation-buys-state-theater",
	"articleSnippet1": "Sep 14, 2016 ... After nearly being converted into office space, the State Theatre and all of its art \ndeco grandeur will be properly restored and renovated over the ...",
	"articleSnippet2": "Jun 18, 2014 ... The Michigan Theater Foundation, a non-profit organization that runs the \nMichigan Theater on East Liberty Street, agreed to buy the State ...",
	"totalMisc": 0,
	"articleTitle2": "Michigan Theater Foundation buys State Theater",
	"address": "233 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160915/pfa.FEA_.DressClothingCloset.9.14.16.0168.jpg?itok=A7q3kI2v",
			"author": "Paul Ahnn",
			"caption": "The State Theater sits closed, ready for a months long renovation, on Wednesday."
		}
	],
	"position": {
		"lat": 42.2794,
		"lng": -83.7404
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"movietheater": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/statetheater.json
// module id = 981
// module chunks = 0